import React from 'react';

const Footer = () => {
    const footerSections = [
        {
            title: "Contact",
            content: [
                "PS in foodservice (Mauritskazerne)",
                "Nieuwe Kazernelaan 2-D42-A12",
                "6711 JC Ede",
                "info@psinfoodservice.com"
            ],
            isText: true
        },
        {
            title: "Diensten",
            class: "footer-hide",
            content: [
                { text: "PS Impact Score", url: "https://psinfoodservice.com/ps-impact-score/" },
                { text: "Producenten", url: "https://psinfoodservice.com/producenten/" },
                { text: "Groothandels", url: "https://psinfoodservice.com/groothandels/" },
                { text: "Afnemers", url: "https://psinfoodservice.com/afnemers/" }
            ],
            isLinks: true
        },
        {
            title: "Meer informatie",
            class: "footer-hide",
            content: [
                { text: "Veelgestelde vragen", url: "/explanation", internal: true },
                { text: "Contact", url: "/helpdesk", internal: true }
            ],
            isLinks: true
        },
        {
            title: "Inspiratie & informatie",
            class: "footer-hide",
            content: [
                "Waardevolle inspiratie, tips en updates op",
                "het gebied van Foodservice in je inbox?"
            ],
            isText: true
        }
    ];

    const renderContent = (section) => {
        if (section.isText) {
            return section.content.map((text, idx) => (
                <React.Fragment key={idx}>
                    {text}<br />
                </React.Fragment>
            ));
        }

        if (section.isLinks) {
            return section.content.map((link, idx) => (
                <React.Fragment key={idx}>
                    {link.internal ? (
                        <a
                            href={link.url}
                            target="_self"
                            rel="noreferrer"
                            className="hover:text-ps-orange block mb-2"
                        >
                            {link.text}
                        </a>
                    ) : (
                        <a
                            href={link.url}
                            target="_blank"
                            rel="noreferrer"
                            className="hover:text-ps-orange block mb-2"
                        >
                            {link.text}
                        </a>
                    )}
                </React.Fragment>
            ));
        }
    };

    return (
        <footer className="bg-ps-gray py-6 footer-container">
            <div className="h-[10px] line-background-bottom" />
            <div className="max-w-[1100px] mx-auto px-4">
                {/* Grid container */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-white">
                    {footerSections.map((section, index) => (
                        <div
                            key={index}
                            className={`pt-8 ${section.class || ''}`}
                        >
                            <h3 className="text-lg font-medium mb-4">
                                {section.title}
                            </h3>
                            <div className="text-sm leading-6">
                                {renderContent(section)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </footer>
    );
};

export default Footer;